import { ChangeDetectionStrategy, Component } from '@angular/core';

import { OrderCancelConfirmationModal } from '../../models/orders-type.model';

import { DialogRef } from '@ui/dialog/dialog-ref';

@Component({
    selector: 'order-cancel-confirm',
    templateUrl: './order-cancel-confirm.component.html',
    styleUrls: ['./order-cancel-confirm.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderCancelConfirmComponent {
    public readonly orderId = this.modalRef.data.orderId;

    public readonly isSubOrder = this.modalRef.data.isSubOrder;

    constructor(private readonly modalRef: DialogRef<void, OrderCancelConfirmationModal>) {}
}
